import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { getPrecisePriceWithCurrency } from 'arbitrip-common/general/utils/Currencies';
import ImageUtils from 'arbitrip-common/client/utils/ImageUtils';
import helpers from './helpers';
import { getBookingTotalToPay } from './utils';

const date_format = 'D MMM YYYY';
const META_SEPARATOR = ' · ';

const formatDate = (date) => {
	const m = moment(date);
	return m.isValid() ? m.format(date_format) : '';
};

const SettlePaymentReservationsListItem = ({ booking }) => {
	const { t } = useTranslation();
	const hotel = _.get(booking, 'hotel');
	const checkIn = formatDate(_.get(booking, 'deal.details.check_in'));
	const checkOut = formatDate(_.get(booking, 'deal.details.check_out'));
	const { total_to_pay, currency } = getBookingTotalToPay(booking);

	const stay = checkIn && checkOut ? `${checkIn} - ${checkOut}` : checkIn || checkOut;
	const meta = [stay, hotel?.name, hotel?.city].filter(Boolean).join(META_SEPARATOR);

	return (
		<div className="settle-payment-reservations-list__item">
			<img
				className="settle-payment-reservations-list__item-image"
				src={`${ImageUtils.getHotelImage(hotel)}`}
				loading="lazy"
				decoding="async"
				alt=""
				onError={(i) => (i.target.style.display = 'none')}
			/>
			<div className="settle-payment-reservations-list__item-details">
				<div className="settle-payment-reservations-list__item-travelers">
					{booking.travelers ? helpers.getTravelersText(booking, t) : ''}
				</div>
				<div className="settle-payment-reservations-list__item-meta">{meta}</div>
			</div>
			<div className="settle-payment-reservations-list__item-pricing">
				{Number.isFinite(total_to_pay) && currency && (
					<div className="settle-payment-reservations-list__item-price">
						{getPrecisePriceWithCurrency(total_to_pay, currency)}
					</div>
				)}
				<div className="settle-payment-reservations-list__item-field">
					<div className="settle-payment-reservations-list__item-field-title">{t('ReservationID')}</div>
					<div className="settle-payment-reservations-list__item-field-content">
						{booking.short_id || booking._id}
					</div>
				</div>
			</div>
		</div>
	);
};

const SettlePaymentReservationsList = ({ bookings }) => {
	const { t } = useTranslation();
	const reservations = bookings || [];

	return (
		<div className="settle-payment-reservations-list">
			<div className="settle-payment-reservations-list__header">
				{t('Bookings.SelectToPay.ReservationsSelected', { count: reservations.length })}
			</div>
			<div className="settle-payment-reservations-list__items">
				{reservations.map((booking) => (
					<SettlePaymentReservationsListItem key={booking.id} booking={booking} />
				))}
			</div>
		</div>
	);
};

export default SettlePaymentReservationsList;
